import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { DocumentCategoryDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-document-category-container',
  templateUrl: './document-category-container.component.html',
  styleUrls: ['./document-category-container.component.scss'],
})
export class DocumentCategoryContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  documentcategorys$: Observable<DocumentCategoryDto[]>;
  loading: boolean;
  isLoadingDocumentCategory$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingDocumentCategory$ = this.gatwayFacade.isLoadingGateway(
      'DocumentCategory'
    );
    this.documentcategorys$ = this.gatwayFacade.loadGateway('DocumentCategory');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteDocumentCategory(deletedValue: any) {
    this.gatwayFacade.remove('DocumentCategory', deletedValue);
  }

  // this method control both the create and update

  onSubmitDocumentCategory(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.DocumentCategorys;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllDocumentCategory = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllDocumentCategory.push(pullData[i]);
      }
    }

    // check if the addAllDocumentCategory array is not empty, then dispatch the data to the store
    if (addAllDocumentCategory.length > 0) {
      this.gatwayFacade.add('DocumentCategory', addAllDocumentCategory);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('DocumentCategory', allUpdates, ['id']);
    }
  }
}
